type EpisodePanelProps = {
  total: number;
  current: number;
  freeCount: number;
  onSelect: (episode: number) => void;
};

export default function EpisodePanel({ total, current, freeCount, onSelect }: EpisodePanelProps) {
  const count = Math.min(total, 100);
  const episodes = Array.from({ length: count }, (_, index) => index + 1);

  return (
    <section
      aria-labelledby="episode-heading"
      className="rounded-2xl border border-foreground-50/10 bg-foreground-50/[0.03] p-3.5 md:p-4"
    >
      <div className="mb-3 flex items-center justify-between gap-2">
        <h2 id="episode-heading" className="flex items-center gap-1.5 font-heading text-base font-bold text-foreground-100">
          <i className="ri-list-check text-primary-300" aria-hidden="true" />
          选集播放
        </h2>
        <span className="shrink-0 text-[11px] text-foreground-500">
          共 {count} 集 · 前 {freeCount} 集免费
        </span>
      </div>

      <div className="no-scrollbar grid max-h-[420px] grid-cols-5 gap-1.5 overflow-y-auto pr-1 sm:grid-cols-6 lg:grid-cols-5">
        {episodes.map((episode) => {
          const active = episode === current;
          const vip = episode > freeCount;
          return (
            <button
              key={episode}
              type="button"
              aria-current={active}
              aria-label={`第 ${episode} 集${vip ? "（VIP）" : ""}`}
              onClick={() => onSelect(episode)}
              className={`relative flex h-9 cursor-pointer items-center justify-center rounded-lg border text-xs font-medium transition-colors ${
                active
                  ? "border-primary-400 bg-primary-500 text-background-950"
                  : "border-foreground-50/10 bg-foreground-50/[0.04] text-foreground-300 hover:border-primary-400/60 hover:text-primary-300"
              }`}
            >
              {episode}
              {vip && !active && (
                <span className="absolute right-0.5 top-0.5 flex h-2 w-2 items-center justify-center rounded-full bg-accent-500" />
              )}
            </button>
          );
        })}
      </div>

      <div className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-1 border-t border-foreground-50/10 pt-3 text-[11px] text-foreground-500">
        <span className="flex items-center gap-1">
          <span className="h-2 w-2 rounded-full bg-primary-500" aria-hidden="true" />
          当前播放
        </span>
        <span className="flex items-center gap-1">
          <span className="h-2 w-2 rounded-full bg-accent-500" aria-hidden="true" />
          VIP 专享
        </span>
        <span>普通用户可免费观看前 {freeCount} 集</span>
      </div>
    </section>
  );
}